import { createSelector } from 'reselect'

const getErrorName = error => error.name
const getErrorProperty = error => error.property
const getErrorMessage = error => error.message
const translateError = createSelector(
  [getErrorName, getErrorProperty, getErrorMessage],
  (name, property, message) => {
    switch (name) {
      case 'required':
        return 'This field is required.'
      case 'minItems':
        switch (property) {
          // This field isn't in use anymore, but it's an example of customizing
          // this error message in case we need to again in the future.
          case '.cid_affiliation':
            return 'You must select at least one list.'
          default:
            break
        }
        break
      default:
        break
    }
    return message
  },
)
export default function transformErrors(errors) {
  return errors.map(error => {
    error.message = translateError(error)
    return error
  })
}
